
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { MovimentacaoAviso } from '@app/models/movimentacao-aviso.model';

@Injectable()
export class MovimentacaoAvisoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  adicionar(movimentacaoAviso: MovimentacaoAviso): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'MovimentacaoAviso', movimentacaoAviso).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  alterar(movimentacaoAviso: MovimentacaoAviso): Observable<any> {
    return this.http
      .put<any>(this.URL_API + 'MovimentacaoAviso', movimentacaoAviso).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `MovimentacaoAviso/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `MovimentacaoAviso/${id}`);
  }

  obterTodos() {
    return this.http.get(this.URL_API + `MovimentacaoAviso`);
  }

  obterPesquisa(descricao: string, pagina: number) {
    descricao = encodeURIComponent(descricao);
    return this.http.get(this.URL_API + `MovimentacaoAviso/pesquisar/?descricao=${descricao}&pagina=${pagina}`);
  }

}
